import {configParamsModule} from "../../configParamsModule"
import {ConfigParamsService} from "../../configParamsService";
import {
    LoadingService,
    MessagesModal,
    RemoteExceptionHandler
} from "../../../../bower_components/front-end-web-commons";
import {IScope} from "angular";

interface Identifiable {
    id: number
}

interface Profile extends Identifiable {
    sourceId: string
}

interface Model {
    userName: string,
    sourceId?: number,
    name: string,
    userPassword: string,
    repeatUserPassword: string,
    parentPermissionGroup?: Identifiable,
    profile?: Profile
}

interface NlgPermissionGroupCreateScope extends IScope {
    onRegisterApi: any
}

export interface PermissionGroupInfo {
    restProfile: Profile,
    permissionGroupCode: number,
    permissionGroupType: string
}

class NlgPermissionGroupCreate {
    private profile?: Profile;
    private permissionGroupType: string;


    model: Model = {
        name: "",
        userName: "",
        userPassword: "",
        repeatUserPassword: "",
    }

    constructor(private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private configParamsService: ConfigParamsService,
                private nlgPasswordService: any,
                private $scope: NlgPermissionGroupCreateScope,
                private $translate: any) {
    }

    save() {
        return this.loadingService(this.configParamsService.createPermissionGroup({
            sourceId: this.model.sourceId,
            name: this.model.name,
            userName: this.model.userName,
            userPassword: this.model.userPassword,
            parentPermissionGroupId: this.model.parentPermissionGroup!.id,
            profileId: this.profile!.id,
        }))
            .catch(this.remoteExceptionHandler())
            .then(() => {
                this.messagesModal("dialog.success", "config.params.save.success")
                    .then(() => this.$scope.onRegisterApi.refreshPermissionGroupPresentationTree())
                this.clear()
            })
    }

    permissionGroups(viewValue: string) {
        return this.configParamsService.findPermissionGroupsBySourceId(viewValue)
    }

    formatTag(tag) {
        if (tag) {
            if (tag.sourceId === "DEFAULT") {
                return `(${tag.sourceId})`;
            }
            return `${tag.sourceId} - ${tag.name}`;
        }
    }

    //Como userName reprensenta nosso e-mail foi criada essa validação para não permitir caracteres especiais(exceto alguns). Issue: DLOGCHA-2865.
    isValidUserName() {
        const regex = /^[a-zA-Z0-9-_.@+]*$/;
        return regex.test(this.model.userName)
    }

    getIconClass() {
        if (this.isValidUserName()) {
            return "fa-exclamation-circle text-muted";
        }
        return "fa-times-circle text-danger";
    };

    getUserNameTooltip() {
        if (this.isValidUserName()) {
            return this.$translate.instant("config.params.permissionGroupCreate.userName.tooltip")
        }
        return this.$translate.instant("config.params.permissionGroupCreate.invalid.characters")
    }

    isValidPassword() {
        const model = this.model;
        return model.userPassword === model.repeatUserPassword && this.nlgPasswordService.isValidPassword(model.userPassword)
    }


    getInfo() {
        if (!this.model.parentPermissionGroup) {
            this.model.sourceId = undefined
            this.profile = undefined
            this.clear()
            return
        }
        this.loadingService(this.configParamsService.getInfo(this.model.parentPermissionGroup)
            .then((info: PermissionGroupInfo) => {
                this.profile = info.restProfile
                this.model.sourceId = info.permissionGroupCode
                this.permissionGroupType = this.$translate.instant(info.permissionGroupType)
            }));
    }

    clear() {
        this.model = {
            sourceId: undefined,
            name: "",
            userName: "",
            userPassword: "",
            repeatUserPassword: "",
            parentPermissionGroup: undefined,
        }
        this.profile = undefined
        this.permissionGroupType = "";
    }

}

export const directive = configParamsModule.directive("nlgPermissionGroupCreate", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./nlgPermissionGroupCreate.html"),
        scope: {
            onRegisterApi: "="
        },
        controllerAs: "ctrl",
        controller: NlgPermissionGroupCreate,

    }
}])